import useAct from 'Workflows/hooks/useAct'

export default function useEntryRules() {
  const act = useAct()
  const entryRules = useSel(s => s.builder.workflow?.entryWorkflowFilter?.rules || [])
  const description = useSel(s => s.local.entryWorkflowFilterDescription)
  const hasRules = entryRules.filter(r => r.type === 'filter').length > 0

  useEffect(() => {
    if (hasRules && !description) {
      act.builder.describeEntryWorkflowFilter()
    }
  }, [hasRules])

  return { entryRules, description, hasRules }
}
